// client/src/trainingRoutes.js — routes for the training portal, kept in one file
// (App.js spreads them into the /dashboard route tree, like wave2Routes.js).
import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import TrainingPage from './pages/secure/TrainingPage';
import TrainingRecordPage from './pages/secure/TrainingRecordPage';

/** Under /dashboard (staff login). */
export const trainingDashboardRoutes = () => [
    <Route key="tr-home" path="training" element={<TrainingPage />} />,
    <Route key="tr-records" path="training/records" element={<TrainingRecordPage />} />,
    <Route key="tr-record" path="training/record/:type/:id" element={<TrainingRecordPage />} />,
];

/** Top level: /training (linked from the public Work With Us page) opens the portal's
 *  Training page; a visitor who is not signed in is sent to the login first. */
export const trainingStandaloneRoutes = () => [
    <Route key="tr-public" path="/training" element={<Navigate to="/dashboard/training" replace />} />,
];
